import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
export function Brand({ light = false }) {
  const { t } = useTranslation();
  return (
    <Link
      to="/"
      className="group inline-flex items-center gap-3"
      aria-label={t("brand.name")}
    >
      <span
        className={`flex size-10 items-center justify-center rounded-xl font-display text-lg font-extrabold ${light ? "bg-white text-navy-950" : "bg-navy-900 text-gold-400"}`}
      >
        {"S"}
      </span>
      <span className="leading-tight">
        <span
          className={`block font-display text-base font-extrabold tracking-tight ${light ? "text-white" : "text-navy-950"}`}
        >
          {t("brand.name")}
        </span>
        <span
          className={`block text-[10px] font-bold uppercase tracking-[0.15em] ${light ? "text-slate-400" : "text-slate-500"}`}
        >
          {t("brand.tagline")}
        </span>
      </span>
    </Link>
  );
}
